import { IconWithText } from 'common/icon/icon-with-text.js';
import { ILocationSummary } from 'types/markerTypesV1/marker-v1-view-type.js';
import { MarkerComponentType } from './utils.js';

export type SnowfallItem = {
  key: MarkerComponentType.Snowfall;
  index: string;
  snowfall: string;
};

export const hasSnowfall = ({ value, label, type }: ILocationSummary): SnowfallItem | undefined => {
  if ('snowFall' in value && value.snowFall) {
    return {
      key: MarkerComponentType.Snowfall,
      index: `${type}-${label}`,
      snowfall: value.snowFall,
    };
  }
  return undefined;
};

export const Snowfall = ({ snowfall }: SnowfallItem) => {
  // name="snow-dark"
  return (
    <IconWithText
      icon="snow"
      classes="IconWithText--vCenter IconWithText--small IconWithText--inline u-mL-xs"
      contentClass="u-textRegular"
      iconClass="svg-fill-textSlate"
    >
      {snowfall}
    </IconWithText>
  );
};
